export const API_URL = process.env.REACT_APP_API_URL;
export const SOCKET_API_URL = process.env.REACT_APP_SOCKET_URL;
export const FRONT_DOMAIN = process.env.REACT_APP_FRONT_DOMAIN;
export const TICK_DOMAIN = process.env.REACT_APP_TICK_DOMAIN;
export const ClASS_DOMAIN = process.env.REACT_APP_CLASS_DOMAIN;
export const ENROLL_DOMAIN = process.env.REACT_APP_ENROLL_DOMAIN;
export const TICK_DOMAIN_MY = process.env.REACT_APP_TICK_DOMAIN_MY;
export const ETICKET_DOMAIN = process.env.REACT_APP_ETICKET_DOMAIN;
export const isETicketDomain =!!ETICKET_DOMAIN && window.location.hostname === new URL(ETICKET_DOMAIN).hostname;
// /n/:token is the public eTicket route on the app domain. It's an entry-only URL —
// router.tsx defines no in-SPA links into or out of it — so a load-time check is safe.
export const isETicketRoute = isETicketDomain || /^\/n\//.test(window.location.pathname);
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const ZOHO_WIDGET_CODE = process.env.REACT_APP_ZOHO_WIDGET_CODE;
export const LIVE_DOMAIN = process.env.REACT_APP_LIVE_DOMAIN;
export const USER_API_PATH = process.env.REACT_APP_USER_API_PATH;

export const IS_LOCAL=process.env.REACT_APP_ENV==='local';
export const IS_PRODUCTION=process.env.REACT_APP_ENV==='production';

export const API_MAILING = process.env.REACT_APP_API_MAILING;
export const NODE_ENV = process.env.REACT_APP_NODE_ENV;
export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_KEY;

export const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID;
export const HOTJAR_SV = process.env.REACT_APP_HOTJAR_SV;

export const GOOGLE_CLIENT_ID = '925559398483-ac1e3r1qldjmofebfv1tmo6j26sua1o9.apps.googleusercontent.com';

// Seatmap Studio (NEW-format map builder/manager) host. master-only for now.
export const SMAP_DOMAIN = process.env.REACT_APP_SMAP_DOMAIN || 'https://maps.tickchak.co.il';

export const TICLI = process.env.REACT_APP_TICK_DOMAIN_TICLI;
export const GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

export const GLASSIX_API_KEY = process.env.REACT_APP_GLASSIX_API_KEY;
export const GLASSIX_SNIPPET_ID = process.env.REACT_APP_GLASSIX_SNIPPET_ID;
export const GLASSIX_SNIPPET_ID_LOGIN = process.env.REACT_APP_GLASSIX_SNIPPET_ID_LOGIN;

export const EXCLUDE_PACKAGE_SUPPORT = [2638, 3201, 3275, 5110, 5296, 6518, 6678, 7950, 8644, 4366, 11002, 11003, 12918, 12919, 18193];
export const EXCLUDE_ACCOUNT_MANAGER_MANAGEMENT = [321, 3275, 4366, 5110, 5296, 6518, 6678, 7950, 8644, 11002, 11003, 18193];
export const DISPLAY_SUSPENDED_CONFIRMATION = [3008,1142];

export const WEATHER_ICONS = 'https://www.visualcrossing.com/img';
export const STATIC_PATH = process.env.REACT_APP_STATIC_PATH;

export const TICKCHAK_SUPPLIERS = [7, 10, 28, 66, 113, 474];
export const ACCESSIBLE_COLOR = '049627';

export const APPLICATION_LOGIN_PATH = 'myapp://auth/callback';

export const ANDROID_APP = 'http://play.google.com/store/apps/details?id=com.tickchak.app';
export const IOS_APP = 'https://apps.apple.com/app/id6464596985';
export const STATIC_IMAGE = 'https://static.tickchak.co.il/images';

export const WAZE_NAV_URL = (query) => `https://waze.com/ul?q=${query}`;
export const GOOGLE_MAPS_NAV_URL = (query) => `https://www.google.com/maps/search/?api=1&query=${query}`;
// export const NEW_WHATSAPP_ID = IS_PRODUCTION ? 88060 : 87041;
// export const NEW_TEMPLATE_EIDS = [87615, 86055];
// export const IS_NEW_TEMPLATE = (eid) => NEW_TEMPLATE_EIDS.includes(eid) || eid > NEW_WHATSAPP_ID;

export const OLD_TEMPLATE_EIDS = [58607,70219,72921,78933,80195,81461,81472,83559,83731,83881,84251,84269,
    84415,84418,84419,84421,84422,84423,84424,84433,84434,84435,84492,84493,84494,84503,84504,84505,84506,84507,
    84508,84514,84515,84516,84632,84759,85269,86115,86116,86117,86118,86119,86121,86122,86123,86125,86135,86136,
    86143,86151,86787];

export const IS_NEW_TEMPLATE = (eid) => !OLD_TEMPLATE_EIDS.includes(eid);

// Timetable new UI threshold
export const TIMETABLE_NEW_UI_EID = 104610;
export const IS_NEW_TIMETABLE_UI = (eid) => eid > TIMETABLE_NEW_UI_EID || IS_LOCAL;
